import {
  loadingAnimationFields,
  topLeadBoardBannerFields,
} from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearanc-revamp/fields';
import { isEqual } from 'lodash';

// const IDENTICAL_LIST = [
//   ...productDetailPageTabBarStyleFields,
//   ...flashSaleBarStyleFields,
//   ...primaryCallToActionButtonFields,
//   ...secondaryCallToActionButtonFields,
//   ...floatingActionButtonFields,
//   ...remainingStockTextStyleFields,
// ];

const OTHERS = [...loadingAnimationFields, ...topLeadBoardBannerFields];

export default (changedFields, { pcForm, tabletForm, mobileForm }) => {
  changedFields.map((field) => {
    func(tabletForm, field);
    func(mobileForm, field);
  });
};

const func = (form, field) => {
  const name = field?.name;
  const value = field?.value;
  if (OTHERS.findIndex((v) => isEqual(name, v)) === -1) {
    form.setFields([
      {
        name,
        value,
      },
    ]);
  }
};
